import React from "react";
import AlertMessage from "../AlertMessage";
import ButtonCSCLed from "shared/Button/ButtonCSCLed";

interface PackingSlipUploaderProps {
  files: File[];
  isDragActive: boolean;
  getRootProps: any;
  getInputProps: any;
  isPreviewable: (file: File) => boolean;
  handleRemove: (index: number) => void;
  errorFile: string | null;
  note: string;
  handleNoteChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: () => void;
  UploadbuttonClicked: boolean;
}

const PackingSlipUploader: React.FC<PackingSlipUploaderProps> = ({
  files,
  isDragActive,
  getRootProps,
  getInputProps,
  isPreviewable,
  handleRemove,
  errorFile,
  note,
  handleNoteChange,
  handleSubmit,
  UploadbuttonClicked
}) => {
  const previewStyle = {
    marginTop: "10px",
    marginBottom: "10px",
    width: "auto",
    height: "100px",
    objectFit: "contain" as const,
  };

  return (
    <div className="w-full">
    <h2
      className="font-medium text-center sm:text-left p-6 text-xl text-gray-800 halloween:text-black halloween:border-white sm:text-3xl md:text-2xl"
      style={{fontFamily: 'Poppins, sans-serif'}}
    >
      Upload a Packing Slip or Invoice
    </h2>
    <div className="w-full md:w-3/4 p-4 px-6 !mt-[-1rem]">
      <div
        {...getRootProps()}
        className="flex items-center justify-center w-full"
      >
        <input {...getInputProps()} />
        <label className="flex flex-col px-6 items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
          <div className="flex flex-col items-center justify-center pt-10 pb-10">
            <svg
              className="w-10 h-10 mb-4 md:mb-2 text-gray-500 dark:text-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <div className="max-w-sm mx-auto md:text-center">
              {isDragActive ? (
                <div className="mb-4 text-center">
                  <p className="mb-2 text-lg text-gray-500 dark:text-gray-400 font-semibold" style={{fontFamily: 'Poppins, sans-serif'}}>
                    Click here to upload your packing slip or invoice.
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400" style={{fontFamily: 'Poppins, sans-serif'}}>
                    Please ensure your picture shows the FULL packing
                    slip or invoice.
                  </p>
                </div>
              ) : (
                <div className="mb-4 text-center">
                  <p className="mb-2 text-lg text-gray-500 dark:text-gray-400 font-semibold" style={{fontFamily: 'Poppins, sans-serif'}}>
                    Click here to upload your packing slip or invoice.
                  </p>
                  <p className="text-sm text-gray-500 dark:text-gray-400" style={{fontFamily: 'Poppins, sans-serif'}}>
                    Please ensure your picture shows the FULL packing
                    slip or invoice.
                  </p>
                </div>
              )}
            </div>
          </div>
        </label>
      </div>

      <div>
        {files.map((file, index) => (
          <div key={index}>
            {!isPreviewable(file) ? (
              <>
                <h3 style={{ marginTop: "10px" }}>{file.name}</h3>
                <button
                  className="block text-csccolor"
                  onClick={() => handleRemove(index)}
                >
                  Remove upload
                </button>
              </>
            ) : (
              <>
                <img
                  src={URL.createObjectURL(file)}
                  alt={file.name}
                  style={previewStyle}
                  
                />
                <h3 style={{fontFamily: 'Poppins, sans-serif'}}>{file.name}</h3>
                <button
                  className="block text-blue-700 font-medium"
                  onClick={() => handleRemove(index)}
                  style={{fontFamily: 'Poppins, sans-serif'}}
                >
                  Remove upload
                </button>
              </>
            )}
          </div>
        ))}
      </div>
      {errorFile && (
        <div className="mt-6 w-full" style={{fontFamily: 'Poppins, sans-serif'}}>
          <AlertMessage message={errorFile} />
        </div>
      )}
    </div>
    <div className="form-group -mt-3 -mb-5">
      <div className="w-full md:w-3/4 p-4 px-6">
        <label className="text-center sm:text-left block text-base text-black-600 halloween:text-black mb-2" style={{fontFamily: 'Poppins, sans-serif'}}>
          Anything we should know regarding the packing slip or
          invoice?
        </label>
        <textarea
          id="CustomerProvidedNote"
          name="CustomerProvidedNote"
          className="form-control border rounded-md focus:outline-none focus:ring  w-full px-4 py-2 text-base leading-6 text-gray-700 placeholder-gray-400 bg-custom-grey border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          maxLength={300}
          rows={3}
          cols={80}
          spellCheck={false}
          value={note}
          onChange={handleNoteChange}
        />
      </div>
    </div>
    <div className="form-group">
      <div className="w-full md:w-3/4 p-4 px-6">
        <p className="text-center sm:text-left text-base text-black-600 halloween:text-black" style={{fontFamily: 'Poppins, sans-serif'}}>
          It may take up to two business days for your reward points
          to appear in your website account.
        </p>
      </div>
    </div>
    <div className="form-group">
      <div className="w-full md:w-3/4 p-4 px-6 flex justify-center md:justify-start" style={{fontFamily: 'Poppins, sans-serif'}}>
        <ButtonCSCLed
          type="submit"
          className="button-container"
          onClick={handleSubmit}
          disabled={UploadbuttonClicked}
        >
          Upload my Proof of Purchase
        </ButtonCSCLed>
        {/* <button
            type="submit"
            onClick={handleSubmit}
            disabled={UploadbuttonClicked}
            className="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-600 dark:focus:ring-offset-0 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700 shadow-xl"
          >
            Upload my Proof of Purchase
          </button> */}
      </div>
      </div>
  </div>
  );
};

export default PackingSlipUploader;
